import { useNavigate } from "react-router";

function Adoptable(props) {
    let navigate = useNavigate();
    return (
        <div className='adoptable'>
        <div id = 'adopt-details'>
          <p>click my eggs boy</p>
        </div>
        <div id = 'adopt-container'>
          <div className='little-guy'>
            <a href="https://dragcave.net/view/nRbzw"><img src="https://dragcave.net/image/nRbzw.gif" style={{borderWidth: 0, maxHeight:'40px'}} alt="Dragon Cave: Adopt one today!"/></a>
            <p>Cetaphil Soda</p>
            </div>
          <div className='little-guy'>
            <a href="https://finaloutpost.net/view/Ozn0e/"><img src="https://finaloutpost.net/s/Ozn0e.png" style={{borderWidth: 0, maxHeight:'40px'}} /></a>
            <p>Oznoe</p>
          </div>
        </div>
        <button id='hatchery-btn' onClick={()=>navigate("/hatchery")}>Feed more beasts</button>

      </div>
    );
  }

  export default Adoptable;